import React from 'react';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

const CTASection = () => {
  return (
    <section className="py-20 bg-card relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-accent/10"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-6">
            Klaar om te beginnen?
          </h2>
          
          <p className="text-xl text-muted-foreground mb-10 max-w-2xl mx-auto">
            Ontdek hoe deze AI-oplossing uw bedrijf kan transformeren. Plan een gratis demo of start met een AI-scan.
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              href="/contact"
              className="px-8 py-4 rounded-lg font-semibold bg-cta text-cta-foreground hover:bg-cta/90 transition-all duration-300 hover:shadow-elevated hover:-translate-y-0.5 flex items-center space-x-2"
            >
              <Icon name="CalendarIcon" size={20} />
              <span>Demo boeken</span>
            </Link>
            
            <Link
              href="/contact"
              className="px-8 py-4 rounded-lg font-semibold border border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 hover:shadow-premium flex items-center space-x-2"
            >
              <Icon name="DocumentMagnifyingGlassIcon" size={20} />
              <span>Gratis AI-scan</span>
            </Link>
          </div>
          
          <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-sm text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircleIcon" size={20} className="text-accent" />
              <span>Geen verplichtingen</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="ClockIcon" size={20} className="text-accent" />
              <span>30 minuten demo</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="ShieldCheckIcon" size={20} className="text-accent" />
              <span>GDPR-compliant</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl"></div>
    </section>
  );
};

export default CTASection;